import { render, staticRenderFns } from "./applyFor.vue?vue&type=template&id=5400a220&scoped=true"
import script from "./applyFor.vue?vue&type=script&lang=js"
export * from "./applyFor.vue?vue&type=script&lang=js"
import style0 from "./applyFor.vue?vue&type=style&index=0&id=5400a220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5400a220",
  null
  
)

export default component.exports